import styles from '../pages/survey/search/SurveySearchPage.module.css';
import React from 'react';

function Pagination({ totalPages, currentPage, onPageChange }) {
  if (totalPages <= 1) return null;
  const pageButtons = [];
  const maxVisiblePages = 10;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }
  if (currentPage > 1) {
    pageButtons.push(
      <button
        key="prev"
        onClick={() => onPageChange(currentPage - 1)}
        className={styles.pageBtn}
      >
        Previous
      </button>
    );
  }
  if (startPage > 1) {
    pageButtons.push(
      <button
        key={1}
        onClick={() => onPageChange(1)}
        className={styles.pageBtn}
      >
        1
      </button>
    );
    if (startPage > 2) pageButtons.push(<span key="dots1">...</span>);
  }
  for (let i = startPage; i <= endPage; i++) {
    pageButtons.push(
      <button
        key={i}
        onClick={() => onPageChange(i)}
        className={`${styles.pageBtn} ${currentPage === i ? styles.pageBtnActive : ''}`}
      >
        {i}
      </button>
    );
  }
  if (endPage < totalPages) {
    if (endPage < totalPages - 1)
      pageButtons.push(<span key="dots2">...</span>);
    pageButtons.push(
      <button
        key={totalPages}
        onClick={() => onPageChange(totalPages)}
        className={styles.pageBtn}
      >
        {totalPages}
      </button>
    );
  }
  if (currentPage < totalPages) {
    pageButtons.push(
      <button
        key="next"
        onClick={() => onPageChange(currentPage + 1)}
        className={styles.pageBtn}
      >
        Next
      </button>
    );
  }
  return (
    <div className={styles.pagination}>
      {pageButtons}
      <span className={styles.paginationInfo}>
        Page {currentPage} of {totalPages}
      </span>
    </div>
  );
}

export default Pagination;
